import { render, staticRenderFns } from "./fontBackColorCom.vue?vue&type=template&id=633c4918&scoped=true"
import script from "./fontBackColorCom.vue?vue&type=script&lang=js"
export * from "./fontBackColorCom.vue?vue&type=script&lang=js"
import style0 from "./fontBackColorCom.vue?vue&type=style&index=0&id=633c4918&prod&lang=css"
import style1 from "./fontBackColorCom.vue?vue&type=style&index=1&id=633c4918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_df42b2ab6613268ca01723f0a843be52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633c4918",
  null
  
)

export default component.exports